/** From this date (IST), P&L / Cash Flow default to consolidated for chain admins. */
export const PNL_CONSOLIDATED_DEFAULT_FROM_IST = new Date('2026-11-30T00:00:00+05:30');

export function shouldDefaultPnlToConsolidated(asOf: Date = new Date()): boolean {
  return asOf >= PNL_CONSOLIDATED_DEFAULT_FROM_IST;
}

/**
 * Default hospital scope for P&L / Cash Flow filters.
 * - Before 30 Nov 2026: active hospital (e.g. Rudram), not consolidated.
 * - From 30 Nov 2026: consolidated (`all` for chain admin; empty for super admin = all).
 */
export function defaultFinancialReportHospitalId(opts: {
  isSuperAdmin: boolean;
  isChainScoped: boolean;
  activeHospitalId?: string | null;
  fallbackHospitalId?: string | null;
  asOf?: Date;
}): string {
  const useConsolidated = shouldDefaultPnlToConsolidated(opts.asOf);
  if (opts.isSuperAdmin) {
    return useConsolidated ? '' : opts.activeHospitalId || opts.fallbackHospitalId || '';
  }
  if (opts.isChainScoped) {
    return useConsolidated
      ? 'all'
      : opts.activeHospitalId || opts.fallbackHospitalId || 'all';
  }
  return '';
}
